import { Box, Button } from '@mui/material';
import React from 'react';
import { useNavigate, useNavigation } from 'react-router-dom';
import OrgInputTextField from '../../components/OrgInputTextField';
import { useTranslation } from 'react-i18next';

export default function ShortestPathOrgNumberInput() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigation = useNavigation();
  
  const [orgNumber1, setOrgNumber1] = React.useState('');
  const [orgNumber2, setOrgNumber2] = React.useState('');

  const isValid = orgNumber1 !== '' && orgNumber2 !== '' && orgNumber1 !== orgNumber2;
  const disabled = navigation.state === 'loading';

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!disabled && isValid) {
      navigate(`/shortestpath/${orgNumber1}/${orgNumber2}`);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 1.5, width: '100%', '& .MuiAutocomplete-root': { flex: '1 1 240px', minWidth: 0 } }}>
      <OrgInputTextField
        disabled={disabled}
        textFieldProps={{
          label: t('shortestPath.fromCompany'),
          error: orgNumber1 === orgNumber2 && orgNumber1 !== '',
          helperText: orgNumber1 === orgNumber2 && orgNumber1 !== '' ? t('shortestPath.mustDiffer') : ""
        }}
        onValidOrgNumberEntered={(value) => setOrgNumber1(value)}
        onInvalidOrgNumberEntered={() => setOrgNumber1('')}
      />
      <OrgInputTextField
        disabled={disabled}
        textFieldProps={{
          label: t('shortestPath.toCompany'),
          error: orgNumber1 === orgNumber2 && orgNumber2 !== '',
          helperText: orgNumber1 === orgNumber2 && orgNumber2 !== '' ? t('shortestPath.mustDiffer') : ""
        }}
        onValidOrgNumberEntered={(value) => setOrgNumber2(value)}
        onInvalidOrgNumberEntered={() => setOrgNumber2('')}
      />
      <Button
        disabled={disabled || !isValid}
        variant="contained"
        sx={{ minHeight: 40 }}
        type="submit"
      >
        {t('common.actions.submit')}
      </Button>
    </Box>
  );
}
